// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3-82f","buttons":"PendingPaymentAlert_buttons__d5_DS"};